import { formatIsoDateCustom, validateDateTimeFormat, currentDatetime } from '@/global/services/helpers/dates'
import { isObject } from 'lodash'
import { api } from '@/global/services/api'
import documentsHistoryHelper from '../documents-history-helper'

const FORM_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
const DISPLAY_DATETIME_FORMAT = 'DD.MM.YYYY. HH:mm'
export default {
  name: 'basicInfoConfig',

  mixins: [
    documentsHistoryHelper
  ],

  data () {
    return {
      internalDataVisible: false,
      subjectSummaryVisible: false,
      historyVisible: false,
      basicDocumentHistoryLoaded: false,
      basicInfoShowLoader: false,
      basicInfoRefreshShowLoader: false,
      basicInfoRefreshDisabled: false
    }
  },

  computed: {
    basicInfo () {
      return {
        title: this.$t('fleet/vehicle.basic_info'),
        key: 'basic-info',
        visible: this.$route.query.category !== 'request_new',
        apiConfig: {
          post: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/basic-info`,
            method: 'post'
          },
          get: {
            module: 'road-maintenance',
            route: `traffic-regulation/${this.$route.params.id}/basic-info`,
            method: 'get'
          }
        },
        editUpdate: (event) => this.basicInfoEditUpdated(event),
        dataFetched: (event) => this.onBasicInfoDataFetched(event),
        afterCancel: (event) => this.onBasicInfoDataFetched(event),
        afterSave: (event) => this.onBasicInfoDataFetched(event, true),
        modifyDataBeforeSend: (event) => this.basicInfoModifyDataBeforeSend(event),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('fleet/vehicle.basic_info'),
            showEditButtons: true,
            showBackButton: {
              uiViewName: this.$route?.meta?.parent_vue_name ?? null
            },
            additional_buttons: [
              {
                type: 'base',
                appendIcon: 'mdi-refresh',
                showLoader: this.basicInfoShowLoader,
                disabled: this.basicInfoRefreshDisabled,
                click: async (event) => {
                  const { fetchTabData } = event || {}

                  this.basicInfoShowLoader = true
                  this.basicInfoRefreshDisabled = true

                  if (typeof fetchTabData === 'function') {
                    fetchTabData()
                  }
                  await this.fetchDocumentsHistory()

                  this.basicInfoShowLoader = false
                  setTimeout(() => {
                    this.basicInfoRefreshDisabled = false
                  }, this.refreshTabBtnTimeout)
                }
              }
            ]
          },
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-internal-blocks-main',
            titleClasses: 'aggregator-requests-internal-title',
            title: this.$t('road-maintenance/aggregator.internal_data'),
            visible: this.internalDataVisible,
            columnsConfig: [
              {
                key: 'foreign_code',
                customValue: () => {
                  return this.$route?.params?.id || null
                },
                title: this.$t('road-maintenance/aggregator.request_id') + ':'
              },
              {
                key: 'doc_class',
                title: this.$t('road-maintenance/aggregator.class') + ':'
              },
              {
                key: 'registry_number',
                title: this.$t('road-maintenance/aggregator.registration_number') + ':'
              },
              {
                key: 'source',
                title: this.$t('road-maintenance/aggregator.source') + ':',
                customValue: (data) => {
                  return data?.source ? this.$t(data.source) : '-'
                }
              }
            ],
            dataKey: 'internal_data'
          },
          {
            component: this.columnsContentComponent,
            key: 'basic-data',
            type: 'columns',
            rows: [
              {
                type: 'fields',
                columnsCount: 3,
                fields: [
                  {
                    key: 'request_type_id',
                    label: this.$t('road-maintenance/aggregator.type_of_request') + '*',
                    type: 'autocomplete',
                    items: this.dropdownValues?.request_type ?? [],
                    autocomplete_options: {
                      allowSearch: false,
                      custom_display_value: (item) => {
                        return item && item.description ? this.$t(item.description) : null
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'road_type_id',
                    label: this.$t('road-maintenance/aggregator.type_of_road') + '*',
                    type: 'autocomplete',
                    items: this.dropdownValues?.road_type ?? [],
                    autocomplete_options: {
                      allowSearch: false,
                      custom_display_value: (item) => {
                        return item && item.description ? this.$t(item.description) : null
                      }
                    },
                    onSelect: (event) => {
                      const { removeDataPropertyByKey, selectedItem } = event || {}

                      if (selectedItem) {
                        if (typeof removeDataPropertyByKey === 'function') {
                          removeDataPropertyByKey('processing_entity')
                        }
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'processing_entity',
                    label: this.$t('road-maintenance/aggregator.responsible_for_processing') + '*',
                    type: 'autocomplete',
                    items: this.dropdownValues?.processing_entity ?? [],
                    autocomplete_options: {
                      allowSearch: false,
                      custom_display_value: (item) => {
                        return item && item.description ? this.$t(item.description) : null
                      }
                    },
                    creatable: false,
                    editable: false,
                    visible: true
                  },
                  {
                    key: 'employee_id',
                    label: this.$t('road-maintenance/aggregator.delegated') + '*',
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'road-maintenance',
                      route: 'traffic-regulation/employees',
                      custom_display_value: (item) => {
                        return item?.full_name ? item.full_name : null
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'status_id',
                    label: this.$t('road-maintenance/excavation-service.status') + '*',
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'road-maintenance',
                      route: 'traffic-regulation/statuses',
                      allowSearch: false,
                      fetchInitial: false,
                      // Make search when a current status value is set the first time (without this callback, in queryParams callback we don't have a current status set yet), because we need to filter statuses by current status
                      onDataLoad: async (event) => {
                        const { makeSearch, items } = event || {}

                        if (typeof makeSearch === 'function' && (!items || !items.length)) {
                          await makeSearch()
                        }
                      },
                      // Set the current status id to the query params
                      queryParams: (event) => {
                        const { id } = event?.selectedValue || {}

                        return {
                          status_id: id || null
                        }
                      },
                      custom_display_value: (value) => {
                        const { description } = value || {}

                        return description ? this.$t(description) : null
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'date_time',
                    type: 'datetime-picker',
                    appendIcon: 'mdi-calendar-month',
                    format: DISPLAY_DATETIME_FORMAT,
                    placeholder: DISPLAY_DATETIME_FORMAT,
                    label: this.$t('road-maintenance/aggregator.request_created_date') + '*',
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !validateDateTimeFormat(value, DISPLAY_DATETIME_FORMAT)) {
                        updateValidationErrors({
                          date_time: this.$t('base.invalid_date').replace(':format', DISPLAY_DATETIME_FORMAT)
                        })
                      }
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'parent_id',
                    label: this.$t('road-maintenance/aggregator.related_subject') + '*',
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'road-maintenance',
                      route: 'traffic-regulation/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            title: this.$t('road-maintenance/aggregator.subject_summary'),
            visible: this.subjectSummaryVisible,
            externalData: this.logsData,
            dataKey: 'summary',
            showLoader: this.logsShowLoader,
            columnsConfig: [
              {
                key: 'created_at',
                title: this.$t('road-maintenance/aggregator.request_created_date') + ':',
                customValue: (data) => {
                  return data?.created_at ? formatIsoDateCustom(data.created_at, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) : ''
                }
              },
              {
                key: 'type',
                title: this.$t('road-maintenance/aggregator.request_type') + ':',
                customValue: (data) => {
                  return data?.type ? this.$t(data.type) : '-'
                }
              },
              {
                key: 'user',
                title: this.$t('road-maintenance/aggregator.request_by') + ':'
              }
            ]
          },
          {
            component: this.rowBlocksDataComponent,
            mainClasses: 'aggregator-requests-blocks-main',
            wrapperClasses: 'aggregator-requests-subject-wrapper',
            title: this.$t('road-maintenance/aggregator.history'),
            visible: this.historyVisible,
            externalData: this.logsData,
            dataKey: 'history',
            showLoader: this.logsShowLoader,
            columnsConfig: [
              {
                key: 'created_at',
                title: this.$t('road-maintenance/aggregator.request_created_date') + ':',
                customValue: (data) => {
                  return data?.created_at ? formatIsoDateCustom(data.created_at, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) : ''
                }
              },
              {
                key: 'type',
                title: this.$t('road-maintenance/aggregator.request_type') + ':',
                customValue: (data) => {
                  return data?.type ? this.$t(data.type) : '-'
                }
              },
              {
                key: 'user',
                title: this.$t('road-maintenance/aggregator.request_by') + ':'
              },
              {
                key: 'edited_fields',
                visible: (event) => {
                  const { blockValue } = event || {}
                  return blockValue !== '-'
                },
                style: {
                  overflow: 'hidden',
                  height: 'auto',
                  flexGrow: 1,
                  minWidth: 'unset'
                },
                title: this.$t('road-maintenance/aggregator.edited_fields') + ':'
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    basicInfoEditUpdated (event) {
      const { edit } = event || {}
      this.edit = !!edit

      if (this.edit) {
        this.internalDataVisible = false
        this.subjectSummaryVisible = false
        this.historyVisible = false
      }
      else {
        this.internalDataVisible = true
        this.subjectSummaryVisible = true
        this.historyVisible = true
      }
    },

    async onBasicInfoDataFetched (event, afterSave = false) {
      const { data: apiData, updateData } = event || {}
      const { formDataForSend } = event || {}

      const data = apiData?.data || formDataForSend || {}

      if (typeof updateData === 'function' && data && isObject(data)) {
        updateData({
          // Modify a date_time date to be in format: DISPLAY_DATETIME_FORMAT
          date_time: data?.date_time ? formatIsoDateCustom(data.date_time, FORM_DATETIME_FORMAT, DISPLAY_DATETIME_FORMAT) : currentDatetime(DISPLAY_DATETIME_FORMAT),
          request_type_id: data?.request_type?.id || data?.request_type_id || null,
          road_type_id: data?.road_type?.id || data?.road_type_id || null,
          status_id: data?.status?.id || data?.status_id || null,
          employee_id: data?.employee?.id || data?.employee_id || null
        })
      }

      this.globalSelectedStatusId = data?.status?.id || data?.status_id || null
      if (!this.basicDocumentHistoryLoaded || afterSave) {
        await this.fetchDocumentsHistory()
        this.basicDocumentHistoryLoaded = true
      }
    },

    async fetchDocumentsHistory () {
      try {
        const { id } = this.$route?.params || {}

        if (id) {
          this.logsShowLoader = true
          const { data } = await api('road-maintenance').get(`traffic-regulation/${id}/logs`)
          this.logsShowLoader = false
          this.logsData = {
            ...this.logsData,
            ...data
          }
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    basicInfoModifyDataBeforeSend (event) {
      const { originalData } = event || {}

      if (originalData) {
        originalData.date_time = originalData.date_time ? formatIsoDateCustom(originalData.date_time, DISPLAY_DATETIME_FORMAT, FORM_DATETIME_FORMAT) : currentDatetime(FORM_DATETIME_FORMAT)
      }

      return originalData
    }
  }
}
